<template>
	<div class="get-in-touch-slide">
		<div class="get-in-touch">
			<NuxtImg
				:src="completeImageUrl(currentTeam.PhotoUrl)"
				:alt="currentTeam?.PhotoMetadata?.alt || ''"
				:title="currentTeam?.PhotoMetadata?.title || ''"
				class="vh-20"
				loading="lazy"
				sizes="1360px"
			/>
			<form class="contact-form mb-4">
				<h4>{{ GetInTouchText }}</h4>
				<div class="input-group">
					<input
						type="button"
						class="form-control open-overlay-btn"
						value="Nachricht eingeben"
						@click="showOverlay"
					/>
					<div class="input-group-append">
						<button type="submit" class="btn btn-submit" @click="showOverlay">
							<font-awesome-icon :icon="['custom', 'paper']" />
						</button>
						<a href="tel:6031112298" class="btn-phone">
							<font-awesome-icon :icon="['custom', 'phone']" />
						</a>
					</div>
				</div>
			</form>
			<SocialMedia :contact="currentTeam" />
		</div>
	</div>
</template>

<script>
import SocialMedia from '../SocialMedia'
import { useTeamStore } from '~/composables/useTeamStore'
import { usePimcoreAssetUrl } from '~/composables/usePimcoreAssetUrl'
export default {
	components: {
		SocialMedia
	},
	data() {
		return {
			GetInTouchText: 'Get in Touch!'
		}
	},
	computed: {
		currentTeam() {
			return useTeamStore().currentTeam.value || {}
		},
		loadingStatus() {
			return useTeamStore().loadingStatus.value
		},
		hideGetInTouch() {
			return useTeamStore().hideGetInTouch.value
		}
	},
	methods: {
		completeImageUrl(imagePath) {
			return usePimcoreAssetUrl(imagePath) || '/images/no-image-placeholder.svg'
		},
		showOverlay() {
			useTeamStore().showOverlay.value = true
		}
	}
}
</script>

<style lang="scss">
.get-in-touch-slide {
	.get-in-touch {
		padding: 5px;
		color: $white;
		.vh-20 {
			height: 234px;
			width: 100%;
			object-fit: cover;
			object-position: 50% 20%;
			margin-bottom: 20%;
		}
		.input-group {
			width: 95%;
			align-items: center;
			input {
				height: 60px;
			}
			svg {
				color: $white;
				font-size: 20px;
			}
			.btn {
				padding: 20px;
			}
			.open-overlay-btn {
				text-align: left;
			}
			.form-control {
				border-radius: 0;
				border-color: $white;
				color: $white;
				&::placeholder {
					color: $white;
				}
			}
		}
		.input-group-append {
			display: flex;
			align-items: center;
			gap: 15px;
			svg {
				color: $white !important;
			}
		}
	}
}
</style>
